import PPolicy from "../../components/PrivacyPolicy";

const Privacy = () => {
  return <PPolicy />;
};

export default Privacy;
